import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              最新文章
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              获取 91.cn 的最新资讯与使用指南
            </p>
          </div>
          <Link
            to="/category/zhinan"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer border border-background-200 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 91.cn`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line" />
                    {article.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/zhinan"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors duration-200"
          >
            查看全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}